import { FC } from 'react';
import { Link } from 'react-router-dom';

import { useBreadCrumbsContext } from '../../../hooks/contexts/breadCrumb.context';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import * as Style from './step.styles';

type StepProps = {
  active: boolean;
  step: number;
  i18n: string[];
  idRef: string;
};

const Step: FC<StepProps> = ({ i18n, active, step, idRef }) => {
  const { breadCrumbs } = useBreadCrumbsContext();
  const { translate } = useI18nContext();
  const isLastStep = step === breadCrumbs.length - 1;
  const pathArray = window.location.pathname.split('/');
  pathArray[1] = breadCrumbs[step].route;
  const newPath = pathArray.join('/');

  const currentStep = breadCrumbs.findIndex((bc) => bc.active);

  return (
    <Style.Container id={`${idRef}-step-${step}`} data-testid={`step-${step}`}>
      <Style.TextStep id={`${idRef}-text-step-${step}`} $active={active}>
        {step < currentStep ? (
          <Link to={newPath}>
            {translate(i18n)}
          </Link>) : (
          translate(i18n)
        )}
      </Style.TextStep>
      {!isLastStep && <Style.DotSeparator id={`${idRef}-dot-separator-${step}`}>•</Style.DotSeparator>}
    </Style.Container>
  );
};

export default Step;
